export const content = {
  logo: { label: 'Logo', type: 'media-manager' },
  menu: {
    label: 'Menu',
    type: 'menu-select',
    hint:
      'Use default to display a menu based on visible pages. You may also select custom menus that you have added through the "Pages & Navigation" panel.'
  }
}

export const design = {
  'background-color': {
    label: 'Background color',
    type: 'background-color',
    category: 'Section'
  },
  padding: {
    label: 'Padding',
    type: 'slider',
    min: 10,
    max: 50,
    suffix: 'px',
    category: 'Section'
  },
  'logo-width': {
    label: 'Logo image width',
    type: 'slider',
    min: 50,
    max: 300,
    step: 10,
    suffix: 'px',
    category: 'Logo'
  },
  'menu-font-family': {
    label: 'Menu font family',
    type: 'google-fonts',
    category: 'Menu'
  },
  'menu-text-color': {
    label: 'Menu text color',
    type: 'text-color',
    category: 'Menu'
  },
  'menu-font-size': {
    label: 'Menu font size',
    type: 'slider',
    min: 12,
    max: 30,
    suffix: 'px',
    category: 'Menu'
  }
}

export const layout = {
  'content-container-fluid': {
    label: 'Full width container',
    type: 'toggle',
    category: 'Structure'
  },
  centered: {
    label: 'Centered',
    type: 'toggle',
    category: 'Structure'
  },
  absolute: {
    label: 'Floating',
    type: 'toggle',
    category: 'Structure',
    hint: 'Set the section to float over other sections.'
  },
  'absolute-background-opacity': {
    label: 'Floating background opacity',
    type: 'slider',
    min: 0,
    max: 1,
    step: 0.01,
    showOn: {
      field: 'absolute',
      operator: '==',
      value: '1'
    },
    category: 'Structure',
    hint:
      'Set the transparency of section while floating. 0 is fully transparent and 1 is fully visible.'
  },
  'show-toggle': {
    label: 'Show mobile toggle',
    type: 'radio',
    options: [
      { value: 'xs', text: 'Mobile' },
      { value: 'sm', text: 'Tablet' },
      { value: 'lg', text: 'Desktop' },
      { value: 'none', text: 'Never' }
    ],
    category: 'Mobile responsive',
    hint: 'Select the display size where the mobile menu toggle starts to show.'
  }
}

export const advanced = {
  'stick-on-scroll': {
    label: 'Sticky header',
    type: 'toggle',
    hint:
      'Set whether the section becomes sticky when scrolling down the page. Only one sticky header is allowed per page. Sticky header will only work on Preview mode.'
  },
  'sticky-background-color': {
    label: 'Sticky header background color',
    type: 'background-color',
    showOn: {
      field: 'stick-on-scroll',
      operator: '==',
      value: '1'
    }
  },
  'sticky-background-opacity': {
    label: 'Sticky header background opacity',
    type: 'slider',
    min: 0,
    max: 1,
    step: 0.01,
    showOn: {
      field: 'stick-on-scroll',
      operator: '==',
      value: '1'
    },
    hint:
      'Set the transparency of section while set to sticky. 0 is fully transparent and 1 is fully visible.'
  },
  'active-style': {
    label: 'Style for active and hover',
    type: 'select',
    options: [
      { value: 'default', text: 'Default' },
      { value: 'none', text: 'None' },
      { value: 'bold', text: 'Bold' },
      { value: 'color-primary', text: 'Color (Primary)' },
      { value: 'color-secondary', text: 'Color (Secondary)' },
      { value: 'color-accent', text: 'Color (Accent)' },
      { value: 'underline', text: 'Underline' },
      { value: 'underline-primary', text: 'Underline (Primary)' },
      { value: 'underline-secondary', text: 'Underline (Secondary)' },
      { value: 'underline-accent', text: 'Underline (Accent)' }
    ],
    required: true,
    hint: 'Select the styling for active menu items and hover.'
  }
}

export default {
  content,
  design,
  layout,
  advanced
}
